<template>
  <div class="popupWrap">
    <SearchForm
      class="single"
      :searchForm="initParam"
      :searchFormTemp="searchFormTemp"
      @normalSearch="normalSearch"
      @normalResetQuery="normalResetQuery"
      width="100px"
    ></SearchForm>
    <DtTable
      ref="multipleTable"
      :data="tableData"
      :options="tableDataOptions"
      :multipleData.sync="multipleData"
      :height="430"
    >
      <!-- <el-table-column slot="checkBox" type="selection" width="70" align="center"></el-table-column> -->
      <el-table-column slot="index" label="序号" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 + (initParam.pageNum - 1) * initParam.pageSize }}
        </template>
      </el-table-column>
    </DtTable>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pageData="initParam"
      :total="total"
      :pageSizes="[10, 15, 25, 50]"
      :showSelect="true"
      :onlyShowSelected.sync="onlyShowSelected"
      :selectNum="selectNum"
    ></Pagination>
    <!-- <div class="dtFormBtn">
      <el-button type="primary" plain @click="close">取消</el-button>
      <el-button type="primary" @click="singleCutConfirm">确认</el-button>
    </div> -->
  </div>
</template>

<script>
import SearchForm from '@/components/layouts/SearchForm';
import DtTable from '@/components/layouts/DtTable';
import Pagination from '@/components/layouts/Pagination';
import { myMixin } from '@/mixins';
import { planInsured } from '@/api/insuranceContract';

export default {
  components: { SearchForm, DtTable, Pagination },
  mixins: [myMixin],
  props: ['isShow', 'tempList', 'policyStatus'],
  data() {
    return {
      dicArr: ['gen.identityType', 'gcbs.occupation.type', 'gcbs.rela.with.staff','gen.gender','gcbs.social.insurance','gcbs.insured.type',],
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: { policyId: '', insuredName: '', insuredStatus: '', planId: '' },
      },
      total: 0,
      selectNum: 0,
      onlyShowSelected: false,
      searchFormTemp: [
        { lable: '被保人姓名', name: 'insuredName', type: 'input' },
        { lable: '被保人状态', name: 'insuredStatus', type: 'select', dic: 'insuredStatus' },
      ],
      tableData: [],
      tableDataOptions: [
        { prop: 'insuredName', label: '被保人姓名' },
        { prop: 'insuredCardType', label: '证件类型', dic: 'gen.identityType' },
        { prop: 'insuredCardNo', label: '证件号' },
        { prop: 'birthday', label: '生日' },
        { prop: 'gender', label: '性别', dic: 'gen.gender' },
        { prop: 'planName', label: '所属计划' },
        { prop: 'occupationCode', label: '职业编码' },
        { prop: 'occupationDec', label: '职业描述' },
        { prop: 'occupationType', label: '职业类别', dic: 'gcbs.occupation.type' },
        { prop: 'socialSecurity', label: '有无社保', dic: 'gcbs.social.insurance' },
        { prop: 'subPolicyId', label: '子保单号' },
        { prop: 'insuredType', label: '被保人类型', dic: 'gcbs.insured.type' },
        { prop: 'relaWithStaff', label: '与职员关系', dic: 'gcbs.rela.with.staff' },
        { prop: 'subInsuredName', label: '关联被保人' },
        { prop: 'subInsuredCardType', label: '关联被保人证件类型', dic: 'gen.identityType' },
        { prop: 'subInsuredCardNo', label: '关联被保人证件号' },
        { prop: 'status', label: '被保人状态', dic: 'insuredStatus' },
      ],
      multipleData: [],
      dialogVisible: false,
      deleteCutObj: {},
    };
  },
  watch: {
    isShow(val) {
      if (val) {
        this.queryData();
      }
    },
    onlyShowSelected(val) {
      if (val) {
        this.tableData = this.multipleData;
        this.total = this.multipleData.length;
        this.$refs.multipleTable.$refs.dtTable.toggleAllSelection();
      } else {
        this.queryData();
      }
    },
    multipleData(val) {
      this.selectNum = val.length;
    },
  },
  methods: {
    init() {
      this.$store.commit('mapDicData', {
        dicCode: 'insuredStatus',
        dicItems: [
          { dicItemCode: '0', dicItemName: '未生效' },
          { dicItemCode: '2', dicItemName: '已生效' },
          { dicItemCode: '3', dicItemName: '已失效' },
        ],
      });
      this.queryData();
    },
    queryData() {
      this.initParam.param.policyId = this.tempList.policyId;
      this.initParam.param.planId = this.tempList.planId;
      // if (this.policyStatus === '1') {
      //   this.initParam.param.insuredStatus = '2';
      // } else {
      //   this.initParam.param.insuredStatus = '3';
      // }
      // if (this.initParam.param.insuredStatus === '') this.initParam.param.insuredStatus = '2';
      planInsured(this.initParam).then(res => {
        if (res.list && res.list.length) {
          this.tableData = res.list.map(item => {
            item.canEdit = true;
            return item;
          });
        } else {
          this.tableData = [];
        }
        this.total = res.total;
      });
    },
    // close() {
    //   this.$emit('update:isShow', false);
    // },
    // singleCutConfirm() {},
  },
};
</script>

<style lang="less">
.smallDialog {
  .el-dialog__body {
    padding: 10px 20px !important;
  }
  .el-button {
    width: 120px !important;
  }
}
</style>
